<div class="features">
  <article>
    <div *ngIf="feature" else loading>
      <h1>{{feature.title.rendered}}</h1>
      <p>created by {{feature._embedded.author[0].name}}</p>
      <div *ngIf="feature.content.rendered" [innerHTML]="feature.content.rendered"></div>
    </div>
    <ng-template #loading><p>Loading...</p></ng-template>
  </article>
</div>